module.exports = __webpack_public_path__ + "static/media/olake-product-4.0efcb25a.svg";